module.exports = __webpack_public_path__ + "static/media/assessment-end-screen-footer.a026297a.png";